module.exports = __webpack_public_path__ + "static/fitbod-logo-705f89c3aeddceecd04f1412a874c44e.png";